import { en } from "./en";

const dict = en;

export function t(key, fallback) {
  return dict[key] ?? fallback ?? key;
}
